import { createContext } from 'react';

const AuthContext = createContext();
const UserDataContext = createContext();
const NavWidthContext = createContext();
const NavigationContext = createContext();
const ErrorMessageContext = createContext();
const ShowArchiveContext = createContext();
const ThemeContext = createContext();
export {
  AuthContext,
  NavWidthContext,
  NavigationContext,
  UserDataContext,
  ErrorMessageContext,
  ShowArchiveContext,
  ThemeContext
};
